import { useIntercom } from './useIntercom'

export function Intercom() {
  useIntercom()

  return null
}
